export const TemplateFieldsBusinessareasCreate = {
  tabs: [
    {
      entry: { key: 'header1', label: 'BUSINESSAREA.DATASHEET.HEADERS.HEADER1' },
      children: [
        { entry: { key: 'name', type: 'text', controlType: 'textbox', label: 'BUSINESSAREA.DATASHEET.FIELDS.NAME', required: true, validationMessage: 'DATASHEET.VALIDATION.REQUIRED.NAME' }},
      ]
    }
  ]
};
